import React from 'react'
import { useFeatureFlags, useFeatureFlagsWithPrefs } from '@fs/zion-flags'
import { RootsTechFlagsProvider, useFlagsContext as useSharedFlagsContext } from '@fs/zion-rootstech'

// Flag treatments were untyped (`any`) before this plumbing was extracted to
// @fs/zion-rootstech, whose `useFlagsContext` now types indexed access as `unknown`.
// Wrap it and keep the return permissive so the existing `useFlagsContext()[FLAGS.x].isOn`
// consumers compile unchanged (behavior identical — same context instance).
/** @returns {any} */
export const useFlagsContext = () => useSharedFlagsContext()

export const RootstechFlagsProvider = ({ children }) => (
  <RootsTechFlagsProvider useFeatureFlags={useFeatureFlags} useFeatureFlagsWithPrefs={useFeatureFlagsWithPrefs}>
    {children}
  </RootsTechFlagsProvider>
)
